module.exports = __webpack_public_path__ + "static/media/search.e49dedbf.svg";